import React, { useEffect, useState } from 'react'
import { Card, CardContent, Typography } from '@mui/material'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { CardTitle } from 'common/components/card/Card'
import Input from 'common/components/form/Input'
import { darkBlue } from 'app/theme'
import { getFullDate } from 'common/utils/DateUtil'
import useBoolean from 'common/hooks/useBoolean'
import GlobalNoteHistoryDialog from './GlobalNoteHistoryDialog'
import { fetchGlobalNote, fetchGlobalNoteHistory, saveGlobalNote, selectGlobalNote, selectGlobalNoteHistory } from './GlobalNoteSlice'

// Note libre partagée par tous les utilisateurs, persistée et versionnée (écran Clients).
// Édition en local ; l'action « Enregistrer » de l'en-tête crée une nouvelle version.
const GlobalNoteCard = () => {
    const dispatch = useDispatch()
    const note = useSelector(selectGlobalNote, shallowEqual)
    const history = useSelector(selectGlobalNoteHistory, shallowEqual)
    const user = useSelector(store => store.app.user, shallowEqual)

    const [draft, setDraft] = useState('')
    const { value: isHistoryOpen, setTrue: openHistory, setFalse: closeHistory } = useBoolean(false)

    useEffect(() => {
        dispatch(fetchGlobalNote())
    }, [dispatch])

    // Re-synchronise le brouillon sur la version courante (chargement initial, après enregistrement).
    useEffect(() => {
        setDraft(note.comment ?? '')
    }, [note.comment])

    const isDirty = (draft ?? '') !== (note.comment ?? '')

    const onSave = () => dispatch(saveGlobalNote({ comment: draft || undefined, updateLogin: user?.login }))

    const onOpenHistory = () => {
        dispatch(fetchGlobalNoteHistory())
        openHistory()
    }

    return (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardTitle
                title='Note partagée'
                color={darkBlue}
                actions={[
                    { icon: 'save', tooltip: 'Enregistrer', onClick: onSave, pulse: isDirty },
                    { icon: 'history', tooltip: 'Historique', onClick: onOpenHistory },
                ]}
            />
            <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <Input
                    value={draft}
                    onChange={v => setDraft(v ?? '')}
                    debounceDelay={0}
                    multiline
                    rows={1}
                    sx={{
                        flexGrow: 1,
                        width: '100%',
                        '& .MuiInputBase-root': { height: '100%', alignItems: 'stretch' },
                        '& .MuiInputBase-input': { height: '100% !important', overflow: 'auto !important' },
                    }}
                />
                {!!note.updateLogin && (
                    <Typography variant='caption' sx={{ fontStyle: 'italic', color: 'text.secondary', mt: 0.5 }}>
                        {`Modifié par ${note.updateLogin} le ${getFullDate(note.updateDate)}`}
                    </Typography>
                )}
            </CardContent>
            <GlobalNoteHistoryDialog open={isHistoryOpen} onClose={closeHistory} history={history} />
        </Card>
    )
}

export default GlobalNoteCard
